import { createContext, useContext, useState } from 'react';
import { CHECKLIST_NAVIGATOR_LIST, BUSINESS_NAVIGATOR_LIST } from '../contants';

const DataContext = createContext({
    navigationList: [],
    setNavigationList: () => {},
    checklistNavigatorList: [],
    setChecklistNavigatorList: () => {},
});

export const DataProvider = ({ children }) => {
    const [navigationList, setNavigationList] = useState(BUSINESS_NAVIGATOR_LIST);
    const [checklistNavigatorList, setChecklistNavigatorList] = useState(CHECKLIST_NAVIGATOR_LIST);

    return (
        <DataContext.Provider
            value={{
                navigationList,
                setNavigationList,
                checklistNavigatorList,
                setChecklistNavigatorList,
            }}
        >
            {children}
        </DataContext.Provider>
    );
};

const useData = () => {
    return useContext(DataContext);
};

export { useData };
